import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';

import TermsFooter from '../../components/TermsFooter';
import Footer from '../../components/Footer';

import useCases from '../../useCases';
import paths from '../../routes/paths';
import {
  dangerouslyShowMenu,
  dangerouslyToggleTerms,
  dangerouslyScrollWatcher,
} from '../../helpers/dangerouslyUseMoves';
import { Images, GlobalStyle } from '../../themes';
import './styles.css';

// @todo: Refactor this page to ReactJS
export default function Terms({ lead }) {
  const history = useHistory();
  const location = useLocation();
  const [fetching, setFetching] = useState();

  useEffect(() => {
    dangerouslyScrollWatcher();
    window.scrollTo(0, 0);
  }, []);

  const onAccept = async () => {
    setFetching(true);
    const result = await useCases.acceptTerms(lead.email);
    setFetching(false);

    if (result.success) {
      history.push(paths.permissions);
    }
  };

  const onDecline = () => {
    const { canBack } = location.state || {};
    if (canBack) {
      history.goBack();
    } else {
      history.replace(paths.activate);
    }
  };

  return (
    <>
      <GlobalStyle showMapImage={false} />
      <header className="main-menu">
        <div className="header-content">
          <a id="instation-logo" href={`${paths.home}#overview`}>
            <img
              id="logo"
              src={Images.branding.inStation}
              alt="InStation logo"
            />
          </a>
          <nav className="options">
            <ul>
              <li>
                <a className="main-view" href={`${paths.home}#overview`}>
                  overview
                </a>
              </li>
              <li>
                <a className="main-view" href={`${paths.home}#features`}>
                  features
                </a>
              </li>
              <li>
                <a className="main-view" href={`${paths.home}#invillia`}>
                  invillia
                </a>
              </li>
              <li>
                <a className="main-view" href={paths.activate}>
                  activate
                </a>
              </li>
              <li id="terms-nav">
                <a id="terms" href="#">
                  terms
                </a>
              </li>
            </ul>
          </nav>

          <div className="made-by">
            <a href="https://invillia.com/global-growth-framework/">
              <p>made by</p>
              <img src={Images.branding.invilliaWhite} alt="Logo Inviilia" />
            </a>
          </div>

          <div className="menu-mobile">
            <img
              id="show-menu"
              onClick={dangerouslyShowMenu}
              src={Images.icons.openMenu}
              alt="Menu icon"
            />
            <img
              id="hide-menu"
              onClick={dangerouslyShowMenu}
              src={Images.icons.closeMenu}
            />
          </div>
        </div>
      </header>

      <div className="terms-menu-mobile" id="terms-menu-mobile">
        <div className="terms-title">
          <p id="separator">&nbsp;</p>
          <p
            id="terms-of-use-mobile-menu"
            className="selected"
            onClick={() =>
              dangerouslyToggleTerms({
                toShow: 'terms-of-use',
                toHide: ['support', 'privacy-policy'],
              })
            }
          >
            Terms
          </p>
          <p id="separator">&nbsp;</p>
          <p
            id="privacy-policy-mobile-menu"
            onClick={() =>
              dangerouslyToggleTerms({
                toShow: 'privacy-policy',
                toHide: ['support', 'terms-of-use'],
              })
            }
          >
            Privacy
          </p>
          <p id="separator">&nbsp;</p>

          <p
            id="support-mobile-menu"
            onClick={() =>
              dangerouslyToggleTerms({
                toShow: 'support',
                toHide: ['terms-of-use', 'privacy-policy'],
              })
            }
          >
            Support
          </p>
        </div>

        <div className="terms-index">
          {/* Terms of use mobile index */}
          <div id="terms-of-use-mobile-index" className="index-align">
            <p className="nav-item" data-link="#terms-of-use-introduction">
              Introdução / Introduction
            </p>
            <p className="nav-item" data-link="#terms-of-use-services">
              Escopo dos Serviços / Scope of Services
            </p>
            <p className="nav-item" data-link="#terms-of-use-prerequisites">
              Pré-Requisitos e Ativação do Produto / Prerequisites and Product
              Activation
            </p>
            <p className="nav-item" data-link="#terms-of-use-changing-terms">
              Alteração dos Termos e Condições de Uso / Changing the Terms and
              Conditions of Use
            </p>
            <p className="nav-item" data-link="#terms-of-use-property-rights">
              Direitos de Propriedade do InStation / InStation Property Rights
            </p>
            <p className="nav-item" data-link="#terms-of-use-updates">
              Atualizações e Indisponibilidade / Updates and Downtime
            </p>
            <p className="nav-item" data-link="#terms-of-use-user-resilience">
              Resilição, Suspensão e Exclusão / Resilience, Suspension and
              Exclusion
            </p>
            <p className="nav-item" data-link="#terms-of-use-feedback">
              Feedback dos Usuários / User Feedback
            </p>
            <p className="nav-item" data-link="#terms-of-use-forum">
              Foro / Forum
            </p>
          </div>

          {/* Privacy Policy mobile index */}
          <div id="privacy-policy-mobile-index" className="index-align">
            <p className="nav-item" data-link="#privacy-policy-introduction">
              Introdução / Introduction
            </p>
            <p className="nav-item" data-link="#privacy-policy-collected">
              Dados Coletados e Forma de Coleta / Collected Data and Collection
              Form
            </p>
            <p
              className="nav-item"
              data-link="#privacy-policy-data-conservation"
            >
              Conservação e Exclusão dos Dados / Data Conservation and Deletion
            </p>
            <p className="nav-item" data-link="#privacy-policy-general-rules">
              Regras gerais dos Termos de Uso / General rules of terms of use
            </p>
            <p className="nav-item" data-link="#privacy-policy-modifications">
              Modificações / Modifications
            </p>
            <p className="nav-item" data-link="#privacy-policy-contact">
              Entre em contato / Contact
            </p>
          </div>

          {/* Support mobile index */}
          <div id="support-mobile-index" className="index-align">
            <p className="nav-item" data-link="#support-introduction">
              Introdução / Introduction
            </p>
            <p className="nav-item" data-link="#support-process">
              Processo de Suporte / Support Process
            </p>
            <p className="nav-item" data-link="#support-first-response">
              Tempo de Primeira Resposta/Diagnóstico / First Response /
              Diagnosis Time
            </p>
            <p className="nav-item" data-link="#support-out-scope">
              Fora do Escopo do Suporte / Out of Scope of Support
            </p>
          </div>
        </div>

        <div className="back-index">
          <p>
            go to the <a href="/">Landing Page</a>
          </p>
        </div>
      </div>

      <div className="terms-container" id="terms-container">
        <div className="terms-menu">
          <div className="terms-title">
            <p
              id="terms-of-use-menu"
              className="selected"
              onClick={() =>
                dangerouslyToggleTerms({
                  toShow: 'terms-of-use',
                  toHide: ['support', 'privacy-policy'],
                })
              }
            >
              Terms
            </p>
            <p id="separator">&nbsp;</p>
            <p
              id="privacy-policy-menu"
              onClick={() =>
                dangerouslyToggleTerms({
                  toShow: 'privacy-policy',
                  toHide: ['support', 'terms-of-use'],
                })
              }
            >
              Privacy
            </p>
            <p id="separator">&nbsp;</p>

            <p
              id="support-menu"
              onClick={() =>
                dangerouslyToggleTerms({
                  toShow: 'support',
                  toHide: ['terms-of-use', 'privacy-policy'],
                })
              }
            >
              Support
            </p>
          </div>

          <div className="terms-index">
            {/* Terms of use web index */}
            <div id="terms-of-use-index" className="index-align">
              <p className="nav-item" data-link="#terms-of-use-introduction">
                Introdução / Introduction
              </p>
              <p className="nav-item" data-link="#terms-of-use-services">
                Escopo dos Serviços / Scope of Services
              </p>
              <p className="nav-item" data-link="#terms-of-use-prerequisites">
                Pré-Requisitos e Ativação do Produto / Prerequisites and Product
                Activation
              </p>
              <p className="nav-item" data-link="#terms-of-use-changing-terms">
                Alteração dos Termos e Condições de Uso / Changing the Terms and
                Conditions of Use
              </p>
              <p className="nav-item" data-link="#terms-of-use-property-rights">
                Direitos de Propriedade do InStation / InStation Property Rights
              </p>
              <p className="nav-item" data-link="#terms-of-use-updates">
                Atualizações e Indisponibilidade / Updates and Downtime
              </p>
              <p className="nav-item" data-link="#terms-of-use-user-resilience">
                Resilição, Suspensão e Exclusão / Resilience, Suspension and
                Exclusion
              </p>
              <p className="nav-item" data-link="#terms-of-use-feedback">
                Feedback dos Usuários / User Feedback
              </p>
              <p className="nav-item" data-link="#terms-of-use-forum">
                Foro / Forum
              </p>
            </div>

            {/* Privacy Policy web index */}
            <div id="privacy-policy-index" className="index-align">
              <p className="nav-item" data-link="#privacy-policy-introduction">
                Introdução / Introduction
              </p>
              <p
                className="nav-item"
                data-link="#privacy-policy-data-collected"
              >
                Dados Coletados e Forma de Coleta / Collected Data and
                Collection Form
              </p>
              <p
                className="nav-item"
                data-link="#privacy-policy-data-conservation"
              >
                Conservação e Exclusão dos Dados / Data Conservation and
                Deletion
              </p>
              <p className="nav-item" data-link="#privacy-policy-general-rules">
                Regras gerais dos Termos de Uso / General rules of terms of use
              </p>
              <p className="nav-item" data-link="#privacy-policy-modifications">
                Modificações / Modifications
              </p>
              <p className="nav-item" data-link="#privacy-policy-contact">
                Entre em contato / Contact
              </p>
            </div>

            {/* Support web index */}
            <div id="support-index" className="index-align">
              <p className="nav-item" data-link="#support-introduction">
                Introdução / Introduction
              </p>
              <p className="nav-item" data-link="#support-process">
                Processo de Suporte / Support Process
              </p>
              <p className="nav-item" data-link="#support-first-response">
                Tempo de Primeira Resposta/Diagnóstico / First Response /
                Diagnosis Time
              </p>
              <p className="nav-item" data-link="#support-out-scope">
                Fora do Escopo do Suporte / Out of Scope of Support
              </p>
            </div>
          </div>
        </div>

        <div className="terms-description sixth-content">
          {/* Terms of use content */}
          <div id="terms-of-use">
            <h2>Termos de Uso / Terms of Use</h2>
            <h4 id="terms-of-use-introduction">Introdução / Introduction</h4>
            <p>
              Agradecemos por utilizar o produto <b>InStation</b>. Este Termo de
              Uso contêm os termos sob os quais a Invillia (fabricante do
              produto) e a itbox.online (única empresa responsável por
              comercializar e dar suporte aos usuários dos produtos
              desenvolvidos pela Invillia) prestam seus serviços e descrevem
              como estes serviços podem ser acessados e utilizados.
            </p>
            <p>
              <i>
                Thank you for using the <b>InStation</b> product. This Term of
                Use contains the terms under which Invillia (product
                manufacturer) and itbox.online (the only company responsible for
                supporting users of products developed by Invillia) provide
                their services and describe how these services can be accessed
                and used.
              </i>
            </p>
            <p>
              A ativação do produto <b>InStation</b> confirma que você concorda
              com esses termos.
            </p>
            <p>
              <i>
                Activation of the <b>InStation</b> product confirms that you
                agree to these terms.
              </i>
            </p>

            <h4 id="terms-of-use-services">
              Escopo dos Serviços / Scope of Services
            </h4>
            <p>
              O <b>InStation</b> é um produto destinado a criar uma
              representação gráfica/virtual da empresa, através de salas
              virtuais que representam áreas ou equipes, e que são ocupadas
              pelos avatares que representam os colaboradores. Dessa forma, é
              possível navegar por clusters (páginas de exibição) e visualizar
              toda a estrutura virtual da empresa, suas áreas ou equipes e as
              pessoas que a compõem.
            </p>
            <p>
              <i>
                <b>InStation</b> is a product designed to create a graphic /
                virtual representation of the company, through virtual rooms
                that represent areas or teams, and that are occupied by avatars
                that represent employees. In this way, it is possible to browse
                clusters (watch pages) and view the entire virtual structure of
                the company, its areas or teams and the people who compose it.
              </i>
            </p>

            <p>
              O trânsito dos colaboradores é livre dentro dos espaços virtuais,
              não havendo uma trava ou vínculo fixo de um avatar à uma sala.
              Sugere-se que ao criar os espaços virtuais, que haja uma
              orientação aos colaboradores para ocuparem a sala virtual que
              representa a sua área ou time. A única exceção à regra do livre
              trânsito de avatares é quando uma sala tem a sua ‘porta fechada’,
              ocasião em que um integrante da sala aciona essa funcionalidade.
              Somente neste caso, o acesso só será permitido se o visitante
              acionar a função ‘bater na porta’, o que notifica todos os
              ocupantes da sala virtual, e pelo menos um deles autoriza a
              entrada.
            </p>
            <p>
              <i>
                The transit of employees is free within the virtual spaces, with
                no lock or fixed link of an avatar to a room. It is suggested
                that when creating virtual spaces, there should be an
                orientation for employees to occupy the virtual room that
                represents their area or team. The only exception to the free
                transit rule for avatars is when a room has its &apos;closed
                door&apos;, when a member of the room activates this
                functionality. Only in this case, access will only be allowed if
                the visitor activates the function &apos;knock on the
                door&apos;, which notifies all occupants of the virtual room,
                and at least one of them authorizes the entry.
              </i>
            </p>
            <p>
              A intensidade e profundidade da experiência do <b>InStation</b> é
              proporcional ao nível de adesão das áreas e colaboradores no uso.
              Também não seria um fator limitador da experiência caso a empresa
              opte que apenas uma parte da empresa o utilize, embora não seja
              possível limitar que usuários da organização o acessem.
            </p>
            <p>
              <i>
                The intensity and depth of the <b>InStation</b> experience is
                proportional to the level of adherence of the areas and
                employees in the use. It would also not be a limiting factor for
                the experience if the company chooses that only part of the
                company uses it, although it is not possible to limit the users
                of the organization to access it.
              </i>
            </p>

            <h4 id="terms-of-use-prerequisites">
              Pré-Requisitos e Ativação do Produto / Prerequisites and Product
              Activation
            </h4>
            <p>
              O <b>InStation</b> é uma aplicação que executa a partir da
              plataforma Microsoft Teams, e é dele que são feitas as
              comunicações por chat, áudio e vídeo. O <b>InStation</b> não tem
              acesso aos conteúdos dessas comunicações. E qualquer
              indisponibilidade de serviço do Microsoft Teams compromete a
              utilização do
              <b>InStation</b>.
            </p>
            <p>
              <i>
                <b>InStation</b> is an application that runs from the Microsoft
                Teams platform, and that is where communications are made via
                chat, audio and video. <b>InStation</b> does not have access to
                the contents of these communications. And any unavailability of
                Microsoft Teams service compromises the use of <b>InStation</b>.
              </i>
            </p>
            <p>
              Por ser uma extensão do Microsoft Teams, o uso do
              <b>InStation</b> tem como pré-requisito o licenciamento do Office
              365 da empresa Microsoft, escolhendo um pacote de serviços que
              compreenda o produto Microsoft Teams. Somente colaboradores que
              tenham uma conta individualizada do Office 365 serão capazes de
              utilizar o <b>InStation</b>. Havendo o cancelamento da conta do
              Office 365, este colaborador não será mais capaz de utilizar o
              <b>InStation</b>, tendo o seu avatar automaticamente removido em
              até 12 horas. Uma vez que esse colaborador deixa de ser um usuário
              do
              <b>InStation</b>, ele deixa de fazer parte da contagem do número
              de usuários do produto.
            </p>
            <p>
              <i>
                As an extension of Microsoft Teams, using
                <b>
                  <b>InStation</b>
                </b>{' '}
                is a prerequisite for licensing Microsoft Office 365, choosing a
                service package that includes the Microsoft Teams product. Only
                employees who have an individual Office 365 account will be able
                to use <b>InStation</b>. If the Office 365 account is canceled,
                this employee will no longer be able to use
                <b>InStation</b>, having their avatar automatically removed
                within 12 hours. Once this employee is no longer an
                <b>InStation</b> user, he is no longer part of the count of the
                number of users of the product.
              </i>
            </p>
            <p>
              Para tanto, é necessário que o responsável pela gestão de licenças
              do Office 365 (maiores detalhes na seção Pré-Requisitos) libere as
              permissões necessárias para que o <b>InStation</b> seja ativado e
              posso operar em conjunto com o Microsoft Teams, da Microsoft.
              Sugere-se também que na ativação do <b>InStation</b>, que seja
              executado os procedimentos para que o ícone do <b>InStation</b>{' '}
              seja exibido automaticamente na interface do Microsoft Teams de
              todos os colaboradores, como forma de aumentar o engajamento na
              utilização do produto.
            </p>
            <p>
              <i>
                For that, it is necessary that the person responsible for
                managing licenses for Office 365 (more details in the
                Prerequisites section) release the necessary permissions for{' '}
                <b>InStation</b> to be activated and I can operate together with
                Microsoft Teams, from Microsoft. It is also suggested that upon
                activation of
                <b>InStation</b>, that the procedures be carried out so that the
                <b>InStation</b> icon is automatically displayed on the
                Microsoft Teams interface of all employees, as a way to increase
                engagement in the use of the product.
              </i>
            </p>
            <p>
              O uso do <b>InStation</b> fica limitado às contas do Office 365
              cuja licença contemplem o Microsoft Teams, e que estejam
              vinculados ao mesmo Tenant ID, que é o identificador único que uma
              empresa que assina produtos da Microsoft recebe. Se uma empresa ou
              grupo econômico tiver mais de um Tenant ID, a assinatura do
              <b>InStation</b> fica condicionada à uma assinatura por Tenant ID,
              não sendo possível mesclar usuários entre uma instância e outra do
              <b>InStation</b>, que ficam vinculados à um único Tenant ID, por
              questões de segurança inerentes à própria plataforma do Microsoft
              Teams.
            </p>
            <p>
              <i>
                The use of <b>InStation</b> is limited to Office 365 accounts
                whose license includes Microsoft Teams, and which are linked to
                the same Tenant ID, which is the unique identifier that a
                company that subscribes to Microsoft products receives. If a
                company or economic group has more than one Tenant ID, the
                subscription of
                <b>InStation</b> is conditioned to a subscription by Tenant ID,
                it is not possible to merge users between one instance and
                another of
                <b>InStation</b>, which are linked to a single Tenant ID, for
                reasons security inherent in the Microsoft Teams platform
                itself.
              </i>
            </p>

            <h4 id="terms-of-use-changing-terms">
              Alteração dos Termos e Condições de Uso / Changing the Terms and
              Conditions of Use
            </h4>
            <p>
              A Invillia e a itbox.online poderão modificar, a qualquer tempo,
              as condições deste Contrato. Nesses casos, a Invillia e/ou a
              itbox.online disponibilizará, com 15 (quinze) dias de antecedência
              à vigência das alterações, alerta em local visível no site e no
              próprio produto <b>InStation</b> acerca da modificação dos seus
              termos. A continuidade do uso do <b>InStation</b> após o fim do
              prazo mencionado será considerada como uma aceitação dos novos
              Termos e Condições de Uso.
            </p>
            <p>
              <i>
                Invillia and itbox.online may modify the conditions of this
                Agreement at any time. In such cases, Invillia and / or
                itbox.online will provide, with fifteen (15) days prior to the
                changes taking effect, an alert in a visible place on the
                website and in the <b>InStation</b> product itself about the
                modification of its terms. Continuing to use <b>InStation</b>{' '}
                after the end of the term will be considered an acceptance of
                the new Terms and Conditions of Use.
              </i>
            </p>

            <h4 id="terms-of-use-property-rights">
              Direitos de Propriedade do InStation / InStation Property Rights
            </h4>
            <p>
              Os Usuários reconhecem que os direitos de qualquer natureza
              relacionados ao <b>InStation</b> são de titularidade exclusiva da
              Invillia, incluindo quaisquer modificações, criações, atualizações
              ou aprimoramentos do <b>InStation</b>.
            </p>
            <p>
              <i>
                Users acknowledge that rights of any nature related to
                <b>InStation</b> are the exclusive property of Invillia,
                including any <b>InStation</b> modifications, creations, updates
                or enhancements.
              </i>
            </p>
            <p>
              A licença de uso concedida aos Usuários do <b>InStation</b> não
              caracteriza de nenhuma forma a transferência da titularidade de
              qualquer tipo de direito da Invillia e itbox.online sobre os
              serviços e produtos da sua titularidade.
            </p>
            <p>
              <i>
                The use license granted to <b>InStation</b> Users does not in
                any way characterize the transfer of ownership of any type of
                rights from Invillia and itbox.online over the services and
                products of its ownership.
              </i>
            </p>
            <p>
              Os Usuários se comprometem a não modificar, copiar, fazer
              trabalhos derivados, acessar, distribuir, realizar engenharia
              reversa, decodificar ou exportar os códigos-fonte, executáveis ou
              quaisquer outros arquivos que promovam o funcionamento do{' '}
              <b>InStation</b>, sendo vedado, ainda, tentar realizar quaisquer
              desses atos.
            </p>
            <p>
              <i>
                Users undertake not to modify, copy, make derivative works,
                access, distribute, reverse engineer, decode or export source
                codes, executables or any other files that promote the operation
                of
                <b>InStation</b>, and it is also forbidden to try to perform any
                of these acts.
              </i>
            </p>
            <p>
              Os Usuários reconhecem, ainda, que as logomarcas, marcas
              registradas, nomes de domínio, nomes comerciais e todos os demais
              nomes ou símbolos que identifiquem o <b>InStation</b> (em
              conjunto, “Marcas”), bem como todos os cabeçalhos, gráficos
              personalizados, desenhos, ícones e scripts (em conjunto, “Layout”)
              do
              <b>InStation</b> são de titularidade exclusiva da Invillia, sendo
              expressamente vedada a cópia, reprodução e/ou uso (e qualquer
              tentativa de realização de quaisquer desses atos) das Marcas e/ou
              do Layout sem a prévia e expressa autorização por escrito da
              Invillia.
            </p>
            <p>
              <i>
                Users further acknowledge that logos, trademarks, domain names,
                business names and all other names or symbols that identify
                <b>InStation</b> (collectively, &quot;Brands&quot;), as well as
                all headers, custom graphics, drawings, <b>InStation</b> icons
                and scripts (together, &quot;Layout&quot;) are the exclusive
                property of Invillia, the copying, reproduction and / or use
                (and any attempt to perform any of these acts) of the Marks and
                / or the Layout without prior and express written authorization
                from Invillia.
              </i>
            </p>
            <p>
              Os Usuários se comprometem a não interromper ou interferir, bem
              como tentar interromper ou interferir, no regular funcionamento do
              <b>InStation</b>, por meio de transmissão de qualquer worm, vírus,
              spyware, bot, spider, crawler ou por qualquer outro meio.
            </p>
            <p>
              <i>
                Users undertake not to interrupt or interfere, as well as to try
                to interrupt or interfere, in the regular functioning of
                <b>InStation</b>, through the transmission of any worm, virus,
                spyware, bot, spider, crawler or by any other means.
              </i>
            </p>

            <h4 id="terms-of-use-updates">
              Atualizações e Indisponibilidade / Updates and Downtime
            </h4>
            <p>
              O <b>InStation</b> poderá sofrer modificações, criações,
              aprimoramentos ou atualizações que impliquem remoção e/ou inclusão
              de funcionalidades e limitações e restrições de acesso, sem que
              seja necessária comunicação prévia aos Usuários, visto que tais
              situações ocorrem em razão da busca pelo melhor funcionamento do
              <b>InStation</b> a fim de fornecer o melhor serviço aos Usuários.
            </p>
            <p>
              <i>
                <b>InStation</b> may undergo modifications, creations,
                enhancements or updates that imply removal and / or inclusion of
                functionalities and limitations and access restrictions, without
                the need for prior communication to Users, since such situations
                occur due to the search for the best functioning of
                <b>InStation</b> in order to provide the best service to Users.
              </i>
            </p>
            <p>
              Tendo em vista a necessidade constante de aprimoramento do
              <b>InStation</b>, este poderá tornar-se indisponível em alguns
              períodos em razão das atualizações a serem realizadas.
            </p>
            <p>
              <i>
                In view of the constant need to improve <b>InStation</b>, it may
                become unavailable in some periods due to the updates to be
                performed.
              </i>
            </p>
            <p>
              A Invillia e a itbox.online se comprometem a manter estrutura
              adequada e a realizar atualizações preferencialmente no período
              compreendido entre 00h00min e 06h00min (BRT) a fim de reduzir os
              riscos de indisponibilidade dos sistemas. Não obstante, tendo em
              vista tratar-se de serviço disponibilizado por meio da internet, é
              possível que ocorram indisponibilidades temporárias. A Invillia e
              a itbox.online ficam isentas de qualquer responsabilidade
              decorrente da indisponibilidade dos serviços, por qualquer motivo,
              seja por questões técnicas ou de outra natureza, inclusive por
              circunstâncias além do controle da Invillia e itbox.online, como,
              por exemplo, enchentes, incêndios, atos governamentais, embargos,
              greves ou outras perturbações trabalhistas, indisponibilidade ou
              interrupção em serviços de telecomunicação, atos praticados por
              terceiros, como ataques, problemas com DNS ou quaisquer outros
              problemas relacionados à conexão e/ou disponibilidade da internet
              e/ou servidor que estejam foram da controle da Invillia e
              itbox.online.
            </p>
            <p>
              <i>
                Invillia and itbox.online are committed to maintaining an
                adequate structure and to carry out updates preferably between
                00:00 and 06:00 (BRT) in order to reduce the risks of
                unavailability of the systems. However, considering that it is a
                service available through the internet, it is possible that
                temporary unavailability will occur. Invillia and itbox.online
                are exempt from any liability arising from the unavailability of
                services, for any reason, whether for technical or other
                reasons, including circumstances beyond the control of Invillia
                and itbox.online, such as floods , fires, government acts,
                embargoes, strikes or other labor disturbances, unavailability
                or interruption in telecommunication services, acts practiced by
                third parties, such as attacks, problems with DNS or any other
                problems related to the connection and / or availability of the
                internet and / or server that are under the control of Invillia
                and itbox.online.
              </i>
            </p>

            <h4 id="terms-of-use-user-resilience">
              Resilição, Suspensão e Exclusão / Resilience, Suspension and
              Exclusion
            </h4>
            <p>
              O cancelamento da assinatura do <b>InStation</b> poderá ser
              solicitado exclusivamente por alguém tenha a representação legal
              da empresa contratante. Usuários que são colaboradores da empresa
              não possuem meios de cancelar o serviço, e deixarão de ser usuário
              mediante o cancelamento da sua conta individual de acesso do
              Office 365 associados à empresa contratante.
            </p>
            <p>
              <i>
                The cancellation of the <b>InStation</b> subscription may be
                requested exclusively by someone who has the legal
                representation of the contracting company. Users who are
                employees of the company have no means of canceling the service,
                and will cease to be a user upon cancellation of their
                individual Office 365 access account associated with the
                contracting company.
              </i>
            </p>
            <p>
              A Invillia e a itbox.online poderão rescindir o presente Contrato
              de forma imotivada, a qualquer momento, mediante o envio de
              notificação por escrito com 30 (trinta) dias de antecedência para
              o e-mail registrado na ocasião da ativação do <b>InStation</b>.
            </p>
            <p>
              <i>
                Invillia and itbox.online may terminate this Agreement without
                reason, at any time, by sending a 30 (thirty) day written notice
                to the email registered at the time of activating{' '}
                <b>InStation</b>.
              </i>
            </p>
            <p>
              A Invillia e a itbox.online se reservam o direito de rescindir ou
              suspender o presente Contrato, impedindo o acesso dos Usuários ao
              <b>InStation</b>, sem prévio aviso, se entender, a seu exclusivo
              critério que (i) há uma ameaça significativa à funcionalidade,
              segurança, integridade ou disponibilidade do <b>InStation</b> ou a
              qualquer conteúdo e dados; (ii) o Usuário está acessando ou usando
              o<b>InStation</b> para cometimento de ato ilícito; (iii) há
              violação a esses Termos de Uso ou Política de Privacidade; ou (iv)
              há violação a leis, regulamentos ou direitos de terceiros.
            </p>
            <p>
              <i>
                Invillia and itbox.online reserve the right to terminate or
                suspend this Agreement, preventing Users from accessing{' '}
                <b>InStation</b>, without prior notice, if they understand, in
                their sole discretion, that (i) there is a significant threat to
                functionality, security , integrity or availability of{' '}
                <b>InStation</b> or any content and data; (ii) the User is
                accessing or using <b>InStation</b> to commit an illegal act;
                (iii) there is a violation of these Terms of Use or Privacy
                Policy; or (iv) there is a violation of laws, regulations or
                third party rights.
              </i>
            </p>

            <h4 id="terms-of-use-feedback">
              Feedback dos Usuários / User Feedback
            </h4>
            <p>
              Os Usuários poderão fornecer feedback, comentário e sugestões de
              melhorias para o <b>InStation</b> (“Feedback”) através do avatar
              robótico que está sempre visível na lateral direita da tela do
              <b>InStation</b>. Qualquer Feedback recebido será considerado não
              confidencial e não será considerado de propriedade do Usuário que
              enviar. O Usuário, no momento que envia um Feedback, concede à
              Invillia uma licença mundial, não exclusiva, livre de royalties,
              irrevogável, sublicenciável e perpétua para utilizar e publicar as
              ideias e materiais para qualquer propósito sem nenhuma
              contrapartida financeira para tanto.
            </p>
            <p>
              <i>
                Users will be able to provide feedback, comments and suggestions
                for improvements to <b>InStation</b> (“Feedback”) through the
                robotic avatar that is always visible on the right side of the
                <b>InStation</b> screen. Any Feedback received will be
                considered non-confidential and will not be considered the
                property of the User you send. The User, when sending a
                Feedback, grants Invillia a worldwide, non-exclusive,
                royalty-free, irrevocable, sublicensable and perpetual license
                to use and publish ideas and materials for any purpose without
                any financial consideration.
              </i>
            </p>

            <h4 id="terms-of-use-forum">Foro / Forum</h4>
            <p>
              Fica eleito o foro da Comarca de São Paulo, Estado de São Paulo,
              Brasil, como o único competente para dirimir dúvidas ou
              controvérsias oriundas deste Contrato, renunciando as Partes a
              qualquer outro, por mais privilegiado que seja.
            </p>
            <p>
              <i>
                The jurisdiction of the District of São Paulo, State of São
                Paulo, Brazil, is elected as the only jurisdiction to resolve
                doubts or controversies arising from this Agreement, renouncing
                the Parties to any other, however privileged it may be.
              </i>
            </p>
          </div>

          {/* Privacy Policy */}
          <div id="privacy-policy">
            <h2>Política de Privacidade / Privacy Policy</h2>
            <h4 id="privacy-policy-introduction">Introdução / Introduction</h4>
            <p>
              Esta Política de Privacidade é parte integrante do Termos de Uso
              que regem a utilização do InStation.
            </p>
            <p>
              <i>
                This Privacy Policy is an integral part of the Terms of Use that
                govern the use of InStation.
              </i>
            </p>
            <p>
              O aceite do Termos de Uso contempla também a Política de
              Privacidade. A presente Política de Privacidade, bem como os
              Termos de Uso do qual é parte integrante, estão disponíveis para
              leitura e consulta pelo Usuário a qualquer tempo por meio do link{' '}
              <a href="https://instation.invillia.com/terms">
                {' '}
                https://instation.invillia.com/terms
              </a>
              .
            </p>
            <p>
              <i>
                Acceptance of the Terms of Use also includes the Privacy Policy.
                This Privacy Policy, as well as the Terms of Use of which it is
                an integral part, are available for reading and consultation by
                the User at any time through the link{' '}
                <a href="https://instation.invillia.com/terms">
                  {' '}
                  https://instation.invillia.com/terms
                </a>
              </i>
            </p>

            <h4 id="privacy-policy-data-collected">
              Dados Coletados e Forma de Coleta / Collected Data and Collection
              Form
            </h4>
            <span>1.1. Fees for Services.</span>
            <p>
              Como a assinatura e ativação do InStation é realizado pela Empresa
              na qual os Usuários possuem algum tipo de vínculo, a mesma precisa
              ter o consentimento dos mesmos no que tange a utilização do
              ferramental de trabalho padrão para a realização das atividades e
              comunicação.
            </p>
            <p>
              <i>
                As the subscription and activation of InStation is carried out
                by the Company in which the Users have some kind of link, it
                must have their consent regarding the use of the standard work
                tool for carrying out activities and communication.
              </i>
            </p>
            <p>
              Para o funcionamento do InStation, as seguintes informações de
              Usuários são coletadas a partir da API do Microsoft Teams:
            </p>
            <ul>
              <li>
                Nome completo, foto e e-mail corporativo do colaborador. Essa
                coleta de informações é realizada no primeiro acesso do usuário
                ao InStation. E as mesmas servem exclusivamente para
                identificarem o usuário no seu avatar virtual dentro do
                InStation.
              </li>
              <li>
                Status em tempo real do Usuário. Essa coleta é realizada em
                intervalos curtos de tempo, para que o seu avatar virtual dentro
                do InStation reflita a sua situação atual dentro do Microsoft
                Teams.
              </li>
              <li>
                Outras informações técnicas. O InStation coleta automaticamente
                algumas informações técnicas, incluindo mas não limitadas a,
                tipo de dispositivo usado para acessar o Serviço, seu IP de
                conexão (com data de hora de acesso), sua localização geográfica
                aproximada, o número de identificação único do seu dispositivo
                (como MAC Address ou IMEI), informações sobre o uso do Serviço,
                o software utilizado para acessar o Serviço, o sistema
                operacional e sua versão do dispositivo utilizado, entre outros.
              </li>
              <li>
                Cookies. O InStation também poderá utilizar de cookies, de modo
                a melhorar sua experiência de navegação. Como o InStation é
                executado dentro da plataforma Microsoft Teams, os parâmetros
                desse recurso estão em conformidade com as regras dessa
                ferramenta.
              </li>
              <li>
                Dados anônimos e estatísticas agregadas. O InStation pode gerar,
                a partir dos dados das atividades dos Usuários, relatórios
                estatísticos anônimos a partir de dados agregados não
                identificados ou identificáveis. Tais dados anonimizados serão
                submetidos a processo que impeça sua re-identificação,
                considerando os meios técnicos e financeiros razoáveis e
                disponíveis e o tempo necessário para tal reversão.
              </li>
            </ul>
            <p>
              <i>
                For InStation to function, the following User information is
                collected from the Microsoft Teams API:
              </i>
            </p>
            <ul>
              <li>
                <i>
                  Full name, photo and corporate email of the employee. This
                  information collection is performed at the user&apos;s first
                  access to InStation. And they are used exclusively to identify
                  the user in their virtual avatar within InStation.
                </i>
              </li>
              <li>
                <i>
                  User real time status. This collection is carried out in short
                  intervals, so that your virtual avatar within InStation
                  reflects your current situation within Microsoft Teams.
                </i>
              </li>
              <li>
                <i>
                  Other technical information. InStation automatically collects
                  some technical information, including but not limited to, type
                  of device used to access the Service, your connection IP (with
                  access time date), your approximate geographical location,
                  your device&apos;s unique identification number ( MAC Address
                  or IMEI), information about the use of the Service, the
                  software used to access the Service, the operating system and
                  its version of the device used, among others.
                </i>
              </li>
              <li>
                <i>
                  Cookies. InStation may also use cookies in order to improve
                  your browsing experience. As InStation runs within the
                  Microsoft Teams platform, the parameters of this feature are
                  in accordance with the rules of this tool.
                </i>
              </li>
              <li>
                <i>
                  Anonymous data and aggregated statistics. InStation can
                  generate anonymous statistical reports from Users&apos;
                  activity data based on unidentified or identifiable aggregated
                  data. Such anonymized data will be submitted to a process that
                  prevents its re-identification, considering the reasonable and
                  available technical and financial means and the time necessary
                  for such a reversal.
                </i>
              </li>
            </ul>
            <p>
              <b>Importante:</b> o InStation é executando como uma extensão do
              Microsoft Teams, e todas as comunicações por chat, áudio e vídeo,
              não passam pela infraestrutura do InStation, de forma que não há o
              acesso, de nenhuma natureza, ao conteúdo dessas comunicações.
            </p>
            <p>
              <i>
                <b>Important:</b> InStation is running as an extension of
                Microsoft Teams, and all chat, audio and video communications do
                not go through the InStation infrastructure, so there is no
                access whatsoever to the content of those communications.
              </i>
            </p>

            <h4 id="privacy-policy-data-conservation">
              Conservação e Exclusão dos Dados / Data Conservation and Deletion
            </h4>

            <p>
              Fornecimento do Serviço e funcionalidades. Os dados coletados e
              utilizados para possibilitar o uso do InStation e de suas
              funcionalidades, serão mantidos enquanto a relação entre o Usuário
              e o InStation existir, sendo que, sem sua conservação, não é
              possível disponibilizar a Plataforma e suas funcionalidades.
            </p>
            <p>
              <i>
                Service provision and features. The data collected and used to
                enable the use of InStation and its functionalities, will be
                maintained as long as the relationship between the User and
                InStation exists, and without preserving it, it is not possible
                to provide the Platform and its functionalities.
              </i>
            </p>
            <p>
              Melhoria da Plataforma e suporte técnico. Os dados coletados para
              permitir a melhoria do InStation e para atendimento do suporte
              técnico serão mantidos pelo tempo necessário para implementação ou
              prestação do auxílio específico solicitado pelo Usuário, podendo
              ser excluídos definitivamente ou anonimizados para compor banco de
              dados agregados com finalidades estatísticas.
            </p>
            <p>
              <i>
                Platform improvement and technical support. The data collected
                to allow the improvement of InStation and to assist technical
                support will be kept for the time necessary to implement or
                provide the specific assistance requested by the User, and can
                be permanently deleted or anonymized to compose an aggregated
                database for statistical purposes.
              </i>
            </p>
            <p>
              No cancelamento do serviço, além da interrupção da utilização do
              InStation, o acesso aos dados históricos armazenados também será
              imediatamente bloqueado. E a Invillia se reserva no direito de
              preservá-los por até 3 meses, e a partir disso, removê-los em
              caráter não reversível ou anonimizá-los para fins estatísticos de
              uso do produto, para servir de insumo para a sua melhoria. Para
              ambos os casos, não será possível realizar a recuperação destes
              dados, mesmo que a Empresa contratante retome a assinatura de
              utilização do produto.
            </p>
            <p>
              <i>
                When canceling the service, in addition to stopping use of
                InStation, access to stored historical data will also be
                immediately blocked. And Invillia reserves the right to preserve
                them for up to 3 months, and thereafter, remove them in a
                non-reversible manner or anonymize them for statistical purposes
                of using the product, to serve as input for their improvement.
                In both cases, it will not be possible to recover this data,
                even if the contracting company resumes the subscription to use
                the product.
              </i>
            </p>
            <p>
              A exclusão dos dados armazenados pelo InStation poderá ser
              requisitada, nas condições estabelecidas pela Lei Geral de
              Proteção de Dados, por meio da própria interface do InStation,
              através do avatar robótico, sempre visível na lateral direita,
              pela opção ‘Abrir um chamado para suporte’. A Invillia declara-se
              comprometida a empreender os melhores esforços para atender a
              todos os pedidos de exclusão, quando cabíveis, o mais breve
              possível. Tal exclusão, quando abranger dados necessários para o
              funcionamento do Serviço, acarretará também a Rescisão dos Termos
              de Uso e a exclusão da Conta do Usuário. Mesmo nesse caso, a
              Invillia poderá manter os dados pessoais armazenados, sem
              sujeitá-los a tratamento ativo, de modo a cumprir com suas
              obrigações legais de guarda de dados. Os dados que venham a compor
              Prontuário Médico Eletrônico serão armazenados por 20 anos
              contados do último registro, conforme Lei nº 13.787/2018 (Lei do
              Prontuário Eletrônico), exceto nos casos expressos em Lei.
            </p>
            <p>
              <i>
                The exclusion of data stored by InStation may be requested,
                under the conditions established by the General Data Protection
                Law, through the InStation interface itself, through the robotic
                avatar, always visible on the right side, through the option
                &apos;Open a support ticket&apos; . Invillia declares itself
                committed to make the best efforts to meet all requests for
                exclusion, when applicable, as soon as possible. Such exclusion,
                when covering data necessary for the operation of the Service,
                will also result in the Termination of the Terms of Use and the
                deletion of the User Account. Even in this case, Invillia will
                be able to keep personal data stored, without subjecting it to
                active treatment, in order to comply with its legal data
                protection obligations. The data that make up the Electronic
                Medical Record will be stored for 20 years counted from the last
                record, according to Law No. 13,787 / 2018 (Electronic Record
                Law), except in the cases expressed in Law.
              </i>
            </p>

            <h4 id="privacy-policy-general-rules">
              Regras gerais dos Termos de Uso / General rules of terms of use
            </h4>

            <p>
              São aplicáveis a esta Política de Privacidade as regras gerais
              aplicáveis aos Termos de Uso, especialmente aquelas relativas à
              lei aplicável, eleição de foro, e exceções de responsabilidade e
              garantia.
            </p>
            <p>
              <i>
                The general rules applicable to the Terms of Use are applicable
                to this Privacy Policy, especially those related to the
                applicable law, choice of forum, and exceptions of liability and
                warranty.
              </i>
            </p>

            <h4 id="privacy-policy-modifications">
              Modificações / Modifications
            </h4>

            <p>
              Nosso serviço pode mudar de tempos em tempos. Por isso, podemos
              modificar unilateralmente esta Política de Privacidade a qualquer
              tempo. Sempre que houver uma mudança relevante dela, você será
              notificado através das informações de contato disponibilizadas. Na
              notificação enviada, você terá acesso ao novo texto da Política de
              Privacidade, bem como um resumo das alterações efetuadas. Após tal
              notificação, ao continuar utilizando o Serviço, você concorda
              automaticamente com os novos termos da Política. Caso não concorde
              com as alterações e queira cancelar o serviço, utilizar o canal de
              suporte dentro da ferramenta, já mencionado. A versão atualizada
              desta Política estará sempre disponível no endereço:
              <a href="https://instation.invillia.com/terms#privacy">
                https://instation.invillia.com/terms#privacy
              </a>
              .
            </p>
            <p>
              <i>
                Our service may change from time to time. Therefore, we may
                unilaterally modify this Privacy Policy at any time. Whenever
                there is a relevant change to it, you will be notified via the
                contact information provided. In the notification sent, you will
                have access to the new text of the Privacy Policy, as well as a
                summary of the changes made. After such notice, by continuing to
                use the Service, you automatically agree to the new terms of the
                Policy. If you do not agree with the changes and want to cancel
                the service, use the support channel inside the tool, already
                mentioned. The updated version of this Policy will always be
                available at:
                <a href="https://instation.invillia.com/terms#privacy">
                  https://instation.invillia.com/terms#privacy
                </a>
                .
              </i>
            </p>

            <h4 id="privacy-policy-contact">Entre em contato / Contact</h4>

            <p>
              Caso você tenha dúvidas sobre esta Política de Privacidade, por
              favor entre em contato: info@invillia.com.
            </p>

            <p>
              <i>
                If you have any questions about this Privacy Policy, please
                contact: info@invillia.com.
              </i>
            </p>
          </div>

          {/* Support content */}
          <div id="support">
            <h2>Suporte ao Usuário / User Support</h2>
            <h4 id="support-introduction">Introdução / Introduction</h4>
            <p>
              O <b>InStation</b> é uma solução super intuitiva e centrada à
              experiência do usuário final. Adicionalmente, oferece um manual
              online dentro da própria interface, acessível a partir de qualquer
              tela do produto, sempre no canto superior direito, a partir do
              símbolo representado pela letra ‘i’.
            </p>
            <p>
              <i>
                <b>InStation</b> is a super intuitive solution focused on the
                end user experience. Additionally, it offers an online manual
                within the interface, accessible from any product screen, always
                in the upper right corner, from the symbol represented by the
                letter &apos;i&apos;.
              </i>
            </p>
            <p>
              Ao assinar o produto <b>InStation</b>, é parte do escopo da
              assinatura a prestação do serviço de suporte ao usuário final do
              produto, sendo este serviço exclusivo para as funcionalidades do
              <b>InStation</b> (excluindo-se demandas não relacionadas, como
              softwares de terceiros ou a utilização de equipamentos
              computacionais que executam o produto, como notebooks ou
              computadores pessoais). Algumas questões essenciais do uso do
              Microsoft Teams que estejam ligadas ao uso do
              <b>InStation</b> poderão ser solucionadas pelo suporte oferecido.
            </p>
            <p>
              <i>
                When subscribing to the <b>InStation</b> product, it is part of
                the scope of the subscription to provide the support service to
                the end user of the product, this service being exclusive to the
                <b>InStation</b> functionalities (excluding unrelated demands,
                such as third-party software or the use of equipment running the
                product, such as notebooks or personal computers). Some
                essential issues regarding the use of Microsoft Teams that are
                linked to the use of <b>InStation</b> can be resolved by the
                support offered.
              </i>
            </p>
            <p>
              Este serviço é oferecido exclusivamente pela empresa itbox.online,
              e fazem parte deste serviço os seguintes tipos de atendimento:
            </p>
            <ul>
              <li>
                Atendimento a Incidentes:
                <ul>
                  <li>Mensagens de erro;</li>
                  <li>Indisponibilidade do serviço</li>
                </ul>
              </li>
              <li>
                Requisições:
                <ul>
                  <li>
                    Ajuste de configurações do ambiente virtual do
                    <b>InStation</b>.
                  </li>
                </ul>
              </li>
              <li>
                Atendimento a dúvidas de uso:
                <ul>
                  <li>
                    Do Microsoft Teams, limitado ao uso da funcionalidade
                    Videoconferência através do <b>InStation</b>;
                  </li>
                  <li>
                    Do <b>InStation</b>.
                  </li>
                </ul>
              </li>
            </ul>

            <p>
              <i>
                This service is offered exclusively by the company itbox.online,
                and the following types of service are part of this service:
              </i>
            </p>
            <ul>
              <li>
                <i>Incident Response:</i>
                <ul>
                  <li>
                    <i>Error messages;</i>
                  </li>
                  <li>
                    <i>Unavailability of the service.</i>
                  </li>
                </ul>
              </li>
              <li>
                <i>Requisitions:</i>
                <ul>
                  <li>
                    <i>
                      Adjust settings for the <b>InStation</b> virtual
                      environment.
                    </i>
                  </li>
                </ul>
              </li>
              <li>
                <i>Answering questions of use:</i>
                <ul>
                  <li>
                    <i>
                      From Microsoft Teams, limited to the use of
                      Videoconferencing functionality through <b>InStation</b>;
                    </i>
                  </li>
                  <li>
                    <i>
                      From <b>InStation</b>.
                    </i>
                  </li>
                </ul>
              </li>
            </ul>

            <h4 id="support-process">Processo de Suporte / Support Process</h4>

            <p>
              Para a realização da abertura de um chamado de suporte, o Usuário
              deverá utilizar o avatar robótico, sempre presente na interface do
              InStation na lateral direita, através da opção ‘Abrir um chamado
              ao suporte’.
            </p>
            <p>
              <i>
                In order to open a support ticket, the User must use the robotic
                avatar, always present in the InStation interface on the right
                side, through the option &apos;Open a ticket to support&apos;.
              </i>
            </p>

            <h4 id="support-first-response">
              Tempo de Primeira Resposta/Diagnóstico / First Response /
              Diagnosis Time
            </h4>
            <table>
              <tr id="title">
                <th id="category">Categoria</th>
                <th id="description">Descrição</th>
                <th id="attendance">Tempo de Primeiro Atendimento</th>
                <th id="diagnostic">Tempo de Diagnóstico</th>
              </tr>

              <tr className="content">
                <td>
                  <p>Crítico</p>
                  <p>
                    <i>Critical</i>
                  </p>
                </td>
                <td>
                  <p>
                    Serviço totalmente indisponível com impacto direto no uso do
                    produto.
                  </p>
                  <p>
                    <i>
                      Service totally unavailable with direct impact on product
                      use.
                    </i>
                  </p>
                </td>
                <td>
                  <p>30 minutos</p>
                  <p>
                    <i>30 minutes</i>
                  </p>
                </td>
                <td>
                  <p>2 horas</p>
                  <p>
                    <i>2 hours</i>
                  </p>
                </td>
              </tr>

              <tr className="content">
                <td>
                  <p>Alto</p>
                  <p>
                    <i>High</i>
                  </p>
                </td>
                <td>
                  <p>
                    Serviço parcialmente indisponível, com impacto direto ao uso
                    do produto.
                  </p>
                  <p>
                    <i>
                      Service partially unavailable, with direct impact on
                      product use.
                    </i>
                    .
                  </p>
                </td>
                <td>
                  <p>60 minutos</p>
                  <p>
                    <i>60 minutes</i>
                  </p>
                </td>
                <td>
                  <p>4 horas</p>
                  <p>
                    <i>4 hours</i>
                  </p>
                </td>
              </tr>

              <tr className="content">
                <td>
                  <p>Médio</p>
                  <p>
                    <i>Medium</i>
                  </p>
                </td>
                <td>
                  <p>
                    Apresentação de erros que não geram interrupções na
                    utilização do produto.
                  </p>
                  <p>
                    <i>
                      Presentation of errors that do not generate interruptions
                      in the use of the product.
                    </i>
                    .
                  </p>
                </td>
                <td>
                  <p>90 minutos</p>
                  <p>
                    <i>90 minutes</i>
                  </p>
                </td>
                <td>
                  <p>8 horas</p>
                  <p>
                    <i>8 hours</i>
                  </p>
                </td>
              </tr>

              <tr className="content">
                <td>
                  <p>Baixo</p>
                  <p>
                    <i>Low</i>
                  </p>
                </td>
                <td>
                  <p>Solicitações e procedimentos padrão.</p>
                  <p>
                    <i>Standard requests and procedures.</i>.
                  </p>
                </td>
                <td>
                  <p>120 minutos</p>
                  <p>
                    <i>120 minutes</i>
                  </p>
                </td>
                <td>
                  <p>24 horas</p>
                  <p>
                    <i>24 hours</i>
                  </p>
                </td>
              </tr>
            </table>

            <p>SLA de primeira Resposta / Diagnóstico: 80%.</p>
            <p>
              <i>First Response / Diagnostic SLA: 80%</i>
            </p>

            <h4 id="support-out-scope">
              Fora do Escopo do Suporte / Out of Scope of Support
            </h4>

            <p>Os seguintes itens NÃO fazem parte do escopo oferecido:</p>
            <ul>
              <li>Licenças de uso de Softwares de terceiros;</li>
              <li>
                Subscrições de produtos além do <b>InStation</b>;
              </li>
              <li>
                Instalação, configuração, suporte, testes e homologação de
                software/aplicativos não mencionados neste documento, incluso
                erros de aplicação (sistemas e aplicativos desenvolvidos pelo
                cliente ou por terceiros);
              </li>
              <li>
                Solução de bugs de software reconhecidos pelo fabricante
                (Microsoft ou Invillia);
              </li>
              <li>
                Problemas de Infraestrutura do cliente ou do fabricante
                (Microsoft ou Invillia);
              </li>
              <li>Treinamento para usuários finais;</li>
              <li>
                Implementação, updates, upgrades ou correções de problemas de
                ambientes do cliente (desktop, servidores, serviços de cloud ou
                qualquer outra aplicação);
              </li>
              <li>
                Quaisquer atividades ou itens não mencionados na descrição do
                escopo técnico desse documento.
              </li>
            </ul>

            <p>
              <i>The following items are NOT part of the scope offered:</i>
            </p>
            <ul>
              <li>
                <i>Third party software usage licenses</i>
              </li>
              <li>
                <i>Product subscriptions in addition to InStation; </i>
              </li>
              <li>
                <i>
                  Installation, configuration, support, tests and approval of
                  software / applications not mentioned in this document,
                  including application errors (systems and applications
                  developed by the customer or by third parties);
                </i>
              </li>
              <li>
                <i>
                  Solution of software bugs recognized by the manufacturer
                  (Microsoft or Invillia);
                </i>
              </li>
              <li>
                <i>
                  Infrastructure problems for the customer or the manufacturer
                  (Microsoft or Invillia);
                </i>
              </li>
              <li>
                <i>
                  Problems with physical infrastructure, telecommunications
                  operators, equipment and building infrastructure;
                </i>
              </li>
              <li>
                <i>Training for end users;</i>
              </li>
              <li>
                <i>
                  Implementation, updates, upgrades or corrections of problems
                  in customer environments (desktop, servers, cloud services or
                  any other application);
                </i>
              </li>
              <li>
                <i>
                  Any activities or items not mentioned in the description of
                  the technical scope of this document.
                </i>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="terms-button" id="terms-button">
        <p id="terms-mobile">
          go to the <a href="/">Landing Page</a>
        </p>
      </div>

      <TermsFooter
        fetching={fetching}
        onAccept={onAccept}
        onDecline={onDecline}
      />
      <Footer />
    </>
  );
}

Terms.propTypes = {
  lead: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
  }),
};
